import React from 'react';
import { FaRocket, FaLightbulb, FaCog, FaBookOpen, FaPenNib } from 'react-icons/fa';
import Language_i18 from '../js/useNationalLanguage.jsx';
import { useSelector } from 'react-redux';
import { Cookies } from '../index.js';
import { isLocalHost } from '../shared/host_utils.js';

const MySlider = () => {
    const { lang } = Language_i18();
    const latest_version = useSelector(state => state.latest_version);
    const getMainDomain = () => {
        const parts = window.location.hostname.split('.');
        return parts.length > 2 ? parts[parts.length - 2] : parts[0];
    };
    const main_domain = !isLocalHost(window.location.hostname)
        ? (Cookies.get("main_domain") || getMainDomain() || "hust")
        : (Cookies.get("main_domain") || "hust");
    const tipsPath = (main_domain == 'hust' && (latest_version == 2 || latest_version == 3))
        ? "/next/features"
        : "/shop/category/tips_home";
    const redirectKey = `feature_redirect_${main_domain}`;
    const featureOneKey = `feature_one_${main_domain}`;
    const featureTwoKey = `feature_two_${main_domain}`;
    const featureThreeKey = `feature_three_${main_domain}`;
    const featureOneSubKey = `feature_oneSub_${main_domain}`;
    const featureTwoSubKey = `feature_twoSub_${main_domain}`;
    const featureThreeSubKey = `feature_threeSub_${main_domain}`;

    // Dữ liệu text đa ngôn ngữ
    const texts = {
        feature_hotTopic_main: { en: 'Featured', vi: 'Nổi bật' },
        feature_one_main: { en: 'Digital Suite', vi: 'Bộ công cụ số' },
        feature_one_nofake: { en: 'Digital Identity Check', vi: 'Tra cứu định danh' },
        feature_two_main: { en: 'Platform Features', vi: 'Platform Features' },
        feature_two_nofake: { en: 'Send new reports', vi: 'Gửi báo cáo mới' },
        feature_three_main: { en: 'Community', vi: 'Cộng đồng' },

        feature_oneSub_main: { en: 'Tools & utility modules.', vi: 'Công cụ Demo & Giải pháp phần mềm' },
        feature_oneSub_nofake: {
            en: 'Machine Learning risk alert.',
            vi: 'Machine Learning cảnh báo rủi ro.',
        },
        feature_twoSub_main: { en: 'Platform modules overview.', vi: 'Chia sẻ kiến thức & cập nhật mới.' },        // SỬA: Mô tả rõ là theo dõi cập nhật trên kênh chính thức (ngầm hiểu là Mạng xã hội)
        feature_threeSub_main: { en: 'Updates & release notes.', vi: 'Theo dõi cập nhật trên kênh chính thức.' },
        feature_viewNow_main: { en: 'Learn more', vi: 'Tìm hiểu thêm' },
        feature_redirect_main: {
            one: "/ai/utility/home_ai",
            two: tipsPath,
            three: "/shop/channel?showadview=true",
        },
        feature_redirect_nofake: {
            one: "/shop/check/lists/search/home",
            two: "/shop/check/orders/posts",
            three: "https://t.me/okikkkkkkkkk",
        },
    };

    const resolveLocalizedText = (value) => {
        if (!value || typeof value !== 'object') return '';
        return value[lang] || value.en || value.vi || '';
    };

    const HotIconRocket = () => (
        <FaRocket className="h-6 w-6 text-pink-300 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:scale-105" />
    );

    const HotIconBulb = () => (
        <div className="relative h-6 w-6">
            <FaLightbulb className="h-6 w-6 text-yellow-300 transition-transform duration-300 group-hover:scale-105" />
            <div className="absolute -bottom-1 -right-1 transition-transform duration-300 group-hover:rotate-12">
                <FaCog className="h-4 w-4 text-blue-300" />
            </div>
        </div>
    );

    const HotIconBook = () => (
        <div className="relative h-6 w-6">
            <FaBookOpen className="h-6 w-6 text-cyan-200" />
            <div className="absolute -bottom-1 -right-1 transition-transform duration-300 group-hover:-rotate-6">
                <FaPenNib className="h-4 w-4 text-pink-300" />
            </div>
        </div>
    );

    const hotCards = [
        {
            key: 'one',
            title: resolveLocalizedText(texts[featureOneKey] || texts.feature_one_main),
            subtitle: resolveLocalizedText(texts[featureOneSubKey] || texts.feature_oneSub_main),
            Icon: HotIconRocket,
            accent: "from-pink-500/40 to-blue-500/30",
        },
        {
            key: 'two',
            title: resolveLocalizedText(texts[featureTwoKey] || texts.feature_two_main),
            subtitle: resolveLocalizedText(texts[featureTwoSubKey] || texts.feature_twoSub_main),
            Icon: HotIconBulb,
            accent: "from-yellow-300/40 to-blue-500/30",
        },
        {
            key: 'three',
            title: resolveLocalizedText(texts[featureThreeKey] || texts.feature_three_main),
            subtitle: resolveLocalizedText(texts[featureThreeSubKey] || texts.feature_threeSub_main),
            Icon: HotIconBook,
            accent: "from-cyan-300/40 to-pink-500/30",
        },
    ];

    return (
        <div className="text-center">
            <div className="text-base sm:text-lg font-semibold text-white/90 tracking-wide mb-2">
                {resolveLocalizedText(texts.feature_hotTopic_main)}
            </div>
            <div className="flex gap-4 sm:gap-6 overflow-x-auto pb-2 md:grid md:grid-cols-2 lg:grid-cols-3 md:overflow-visible md:pb-0">
                {hotCards.map((card) => (
                    <a
                        key={card.key}
                        href={(texts[redirectKey] || texts.feature_redirect_main)?.[card.key] || "#"}
                        className="group block no-underline min-w-[260px] sm:min-w-[280px] md:min-w-0"
                        style={{ textDecoration: 'none' }}
                    >
                        <div className={`rounded-3xl p-[1px] bg-gradient-to-br ${card.accent} group-hover:from-pink-500/70 group-hover:to-blue-500/60`}>
                            <div
                                style={{ willChange: 'transform' }}
                                className="relative h-full rounded-3xl bg-slate-900/80 border border-white/15 px-5 py-3 sm:px-6 sm:py-4 overflow-hidden no-underline transition-transform duration-200 group-hover:-translate-y-1 group-hover:scale-[1.02]"
                            >
                                <div className="absolute inset-0 opacity-40">
                                    <div className="absolute -right-8 top-6 h-24 w-24 rounded-full bg-pink-500/10 blur-2xl" />
                                    <div className="absolute -left-10 bottom-6 h-24 w-24 rounded-full bg-blue-500/10 blur-2xl" />
                                    <div className="absolute inset-0 bg-[linear-gradient(120deg,rgba(236,72,153,0.08)_0%,rgba(59,130,246,0.08)_50%,rgba(168,85,247,0.08)_100%)]" />
                                </div>
                                <div className="relative z-10 flex flex-col items-start gap-2">
                                    <div className="flex items-center justify-between w-full">
                                        <div className="flex h-11 w-11 items-center justify-center rounded-2xl border border-white/20 bg-white/10">
                                            <card.Icon />
                                        </div>
                                        <span className="text-[10px] uppercase tracking-[0.3em] text-white/50">
                                            {resolveLocalizedText(texts.feature_viewNow_main)}
                                        </span>
                                    </div>
                                    <h3 className="text-base sm:text-lg font-bold tracking-tight text-white no-underline mb-1">
                                        {card.title}
                                    </h3>
                                    <p className="text-sm text-gray-400 leading-relaxed no-underline">
                                        {card.subtitle}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </a>
                ))}
            </div>
        </div>
    );
};

export default MySlider;
